module.exports = __webpack_public_path__ + "static/media/Ashe.4c292dfc.png";